import type { SimulatorItem } from '@vedalib/editor/lib/elements'
import { createItem } from '@vedalib/editor/lib/elements/elements/Simulator/constants'
import React, { useCallback } from 'react'

import type { IRenderButtonAddItem } from 'components/uiKit/ArrayControl/types'
import Button from 'components/uiKit/Button'
import { KitSize } from 'components/uiKit/KitTypes'
import { setElement } from 'services/Store/Project/actions'
import { useProjectContext, useProjectDispatch } from 'services/Store/Project/hooks'
import { getActiveElementId, getElementState } from 'services/Store/Project/selectors'
import { t } from 'services/Translation'

import type { SimulatorState } from './simulatorTypes'

const SimulatorFormValueItemAdd: React.FC<IRenderButtonAddItem<SimulatorItem>> = ({
  name,
  max,
  array,
  onChange,
}) => {
  const dispatch = useProjectDispatch()
  const elementId = useProjectContext(getActiveElementId)
  const state = useProjectContext(getElementState, elementId || '')

  const handleAdd = useCallback(() => {
    const item = createItem(`${t('elements.simulator.form.item')} ${array.length + 1}`)
    onChange?.([...array, item], { command: 'add', item })

    if (elementId) {
      const newState: SimulatorState = { ...state, active: item.value }
      dispatch(setElement({ id: elementId, value: newState }))
    }
  }, [onChange, dispatch, array, elementId, state])

  return (
    <Button
      disabled={Boolean(max && array.length >= max)}
      name={`${name}.addItem`}
      onClick={handleAdd}
      size={KitSize.L}
      fluid
    >
      {t('uiKit.button.add')}
    </Button>
  )
}

export default React.memo(SimulatorFormValueItemAdd) as typeof SimulatorFormValueItemAdd
